import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const DentalExaminations: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-green-primary">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            viewBox="0 0 10 11"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-16 h-16 fill-white"
                        >
                            <path d="M3.64726 0.742188L3.62383 0.71875L4.49101 1.39844L5.07695 1.84375C5.24101 1.98438 5.47539 1.9375 5.59258 1.77344C5.7332 1.60938 5.70976 1.375 5.5457 1.25781L5.07695 0.90625L5.14726 0.835938C5.56914 0.460938 6.13164 0.25 6.69414 0.25C7.9832 0.25 9.01445 1.30469 9.01445 2.59375V2.64062C9.01445 3.01562 8.94414 3.36719 8.78008 3.71875L8.21758 4.82031C8.12383 5.03125 8.05351 5.24219 8.00664 5.47656L7.13945 10.3047C7.09258 10.5625 6.88164 10.75 6.60039 10.75C6.34258 10.7734 6.1082 10.5859 6.03789 10.3281L5.3582 7.49219C5.26445 7.09375 4.93633 6.8125 4.53789 6.8125C4.13945 6.8125 3.78789 7.09375 3.69414 7.49219L3.01445 10.3281C2.94414 10.5859 2.70976 10.7734 2.45195 10.7734C2.1707 10.75 1.95976 10.5625 1.91289 10.3047L1.0457 5.47656C0.998826 5.24219 0.928514 5.03125 0.834764 4.82031L0.272264 3.71875C0.108201 3.36719 0.0378885 3.01562 0.0378885 2.64062V2.5C0.0378885 1.25781 1.02226 0.25 2.26445 0.25C2.75664 0.25 3.24883 0.4375 3.64726 0.742188Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={<div className="font-700">{sectionName || 'Dental Examinations'}</div>}
                key="1"
            >
                <p className="mr-16 space-y-2">
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dental_examinations_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dental_examinations_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dental_examinations_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dental_examinations_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dental_examinations_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dental_examinations_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Key Elements</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dental_examinations_key_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dental_examinations_key_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dental_examinations_key_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default DentalExaminations;
